import { gql } from '@apollo/client';

export const getPlaylist = gql`
  query getPlaylist($id: ID!) {
    getPlaylist(id: $id) {
      id
      courses {
        thumbnail {
          file {
            key
          }
        }
        id
        name {
          languageCode
          value
        }
      }
    }
  }
`;

export const listPlaylists = gql`
  query listPlaylists($filter: PlaylistFilter, $pagination: PaginationInput) {
    listPlaylists(filter: $filter, pagination: $pagination) {
      id
      name {
        languageCode
        value
      }
    }
  }
`;
